/* @generated */

// src/assets/ui-icon/line/upgrade.tsx
import * as React from "react";
var UpgradeLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m11.86 8.96 2.86 2.75-1.04 1.08-1.07-1.028V15.5h-1.5v-3.739l-1.07 1.03L9 11.708l2.86-2.75Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12c0 5.159 2.841 8 8 8s8-2.841 8-8-2.841-8-8-8-8 2.841-8 8Zm1.5 0c0-4.374 2.126-6.5 6.5-6.5 4.374 0 6.5 2.126 6.5 6.5 0 4.374-2.126 6.5-6.5 6.5-4.374 0-6.5-2.126-6.5-6.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UpgradeLine
};
